import { useCurrentBreakpointValue } from '@change-corgi/design-system/responsive';

import { useClearedQueryParamValue } from 'src/app/shared/hooks/location';

export function useShowSignForm(): boolean {
	const isMobile = useCurrentBreakpointValue([true, false]);
	return useClearedQueryParamValue('show_sign') === 'true' && isMobile;
}
